import React, { useRef, useState } from 'react';
import './App.css';
import { useNavigate, useLocation } from 'react-router-dom';
import BackButton from './BackButton';

function QuickStartGuidePlates() {
  const navigate = useNavigate();
  const location = useLocation();
  const fileInputRef = useRef(null);

  // Keep all files in state, including those passed back from the confirm
  // screen when the user chooses "Upload more files".
  const [files] = useState(location.state?.files || []);

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // allow re-uploading same file
      fileInputRef.current.click();
    }
  };

  const handleFilesSelected = (event) => {
    const fileList = event.target.files;
    const newFiles = fileList ? Array.from(fileList) : [];
    if (newFiles.length === 0) return;

    // Merge new files with existing files, avoiding duplicates by name+size
    const mergedFiles = [
      ...files,
      ...newFiles.filter(
        nf => !files.some(f => f.name === nf.name && f.size === nf.size)
      ),
    ];

    navigate('/license-plate-confirm', {
      state: { files: mergedFiles },
    });
  };

  const handleSupportClick = () => {
    navigate('/support');
  };

  return (
    <div className="QuickStartGuidePlates">
      <h1 className="QuickStartGuidePlates-title">
        Upload your custom<br />license plate
      </h1>
      <div className="QuickStartGuidePlates-desc">
        Please use the button below to transfer the digital versions of your dealership plate and/or frame.
        <br /><br />
        These files should be sent to us in the one of the following formats:
        <ol className="QuickStartGuidePlates-list">
          <li>
            Printable Vector Graphics (.eps format) <span className="QuickStartGuidePlates-italic">*Preferred*</span>
          </li>
          <li>
            High-resolution Image File (.jpg, .png, etc.) – 2400x1200px resolution minimum.
          </li>
        </ol>
      </div>

      <button
        className="QuickStartGuidePlates-upload-btn"
        type="button"
        onClick={handleUploadClick}
      >
        <div className="QuickStartGuidePlates-upload-icon">⬆️</div>
        Upload Dealer Plate Images
      </button>

      <input
        ref={fileInputRef}
        type="file"
        accept=".eps,image/*"
        multiple
        style={{ display: 'none' }}
        onChange={handleFilesSelected}
      />

      <div className="QuickStartGuidePlates-support">
        Questions?{' '}
        <span className="support-link" onClick={handleSupportClick}>Click here</span>
        {' '}to reach out to our support team directly.
      </div>
      <BackButton />
    </div>
  );
}

export default QuickStartGuidePlates;
